export default __webpack_public_path__ + "static/media/hard_drive_es.58486590.svg";